// extracted by mini-css-extract-plugin
export default {"text":"required-auth-modal_text__K0v2y","mt-5":"required-auth-modal_mt-5__1wxx2","mt-3":"required-auth-modal_mt-3__WgtvN"};